import { Condition } from "@types-runway/condition";

/**
 * Keeps the first entry of every condition, identified by its product name. A case holds a
 * condition at most once: a repeated entry would repeat that condition's questionnaire pages.
 */
export const uniqueConditions = (conditions: Condition[]): Condition[] =>
  conditions.filter(
    (condition, position) =>
      conditions.findIndex((other) => other.product.name === condition.product.name) === position
  );
